import identify from "./identify"
import trackEvent from "./track-event"
import Gleap from "gleap"

export default async function useLiveChat() {
    // analytics
    Gleap.on("open", () => {
        trackEvent("Gleap widget Opened")
        identify()
    })
    Gleap.on("close", () => {
        trackEvent("Gleap widget Closed")
    })
    Gleap.on("conversation-started", (data) => {
        trackEvent("Gleap user started a new conversation with optional workflow.", { data })
    })
    Gleap.on("feedback-sent", (formData) => {
        trackEvent("Gleap did send a feedback item.", { data: formData })
    })
    Gleap.on("outbound-sent", (outboundData) => {
        trackEvent("Gleap did send survey results.", { data: outboundData })
    })
    Gleap.on("flow-started", (flow) => {
        trackEvent("The user selected a flow", { data: flow })
    })
    Gleap.on("error-while-sending", () => {
        trackEvent("Gleap error while sending")
    })
    Gleap.on("email-sent", (params) => {
        trackEvent("Gleap Email Sent", params)
    })
}
